import React from "react";
import Grid from "@material-ui/core/Grid";
import { _ProductsTabNav } from "./ProductsTabNav";

interface IProductsTabProps {
    GroupedProducts: any[];
    RenderTabContent: (index: number) => React.ReactNode;
}

export const _ProductsTab: React.FC<IProductsTabProps> = ({ GroupedProducts, RenderTabContent }) => {
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const onClickProduct = (index: number) => setSelectedIndex(index);

    return (
        <Grid container spacing={4}>
            <Grid item xs={6} md={3}>
                <_ProductsTabNav Products={GroupedProducts} SelectedIndex={selectedIndex} OnClick={onClickProduct} />
            </Grid>
            <Grid item xs={6} md={9}>
                {RenderTabContent(selectedIndex)}
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/CompanyProducts/ProductsTab.tsx